import React, { Dispatch, useCallback, useEffect, useRef } from 'react'
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { connect } from 'react-redux';
import NumberInput from '../../common/NumberInput';
import { addSourceInfoInCalculationFlow, updateDecimalSourceValue, updateSource } from '../../../../redux/Calculations/CalculationsActions';
import StringInput from '../../common/StringInput';
import { ToggleButton } from '@mui/material';
import DirectionToggleButton from './DirectionToggleButton'

const SplitSettings = ({

    calculations,
    tabTileProps,
    addSourceInfoIntoCalculationFlow,
    updateSourceData

}: any) => {

    const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
    const currentCalculationSession = calculations.properties[propKey]?.currentCalculationSession;
    const activeFlowUid = currentCalculationSession.activeFlow;
    const allSourcesInFlowArray = currentCalculationSession?.calculationInfo?.flows[activeFlowUid][0]?.source;
    const [firstInputFocused, setFirstInputFocused] = React.useState(false);
    const [secondInputFocused, setSecondInputFocused] = React.useState(false);
    const [firstSourceCardHoverActive, setFirstSourceCardHoverActive] = React.useState(false);
    const [secondSourceCardHoverActive, setSecondSourceCardHoverActive] = React.useState(false);
    const [firstInputValue, setFirstInputValue] = React.useState(allSourcesInFlowArray?.length === 4 ? allSourcesInFlowArray[1] : allSourcesInFlowArray[0]);
    const [secondInputValue, setSecondInputValue] = React.useState(allSourcesInFlowArray?.length === 4 ? allSourcesInFlowArray[2] : allSourcesInFlowArray[1]);
    const [directionInputValue, setDirectionInputValue] = React.useState(allSourcesInFlowArray?.length === 4 ? allSourcesInFlowArray[3]: allSourcesInFlowArray[2]);

    return (
        <div style={{ height: "100%", padding: "10px", borderTop: "1px solid #ccc" }}>
            <div
                style={{ display: 'flex', flexDirection: 'column', marginTop: "10px" }}
                onMouseEnter={() => setFirstSourceCardHoverActive(true)}
                onMouseLeave={() => setFirstSourceCardHoverActive(false)}
            >
                <span style={{ fontWeight: 'bold', color: 'gray', textAlign: 'start', display: 'flex', gap: '10px', justifyContent: "space-between" }}>Delimiter</span>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '97%',
                    margin: '0 4px',
                    padding: "0 4px",
                    border: firstInputFocused ? '1px solid #2BB9BB' : '1px solid lightgray',
                    color: 'rgb(128, 128, 128)',
                    marginTop: "5px"
                }}> 
                    <StringInput
                        onBlur={() => {
                            updateSourceData(propKey, 0, firstInputValue);
                        }}
                        autofocus={false}
                        placeholder='Enter delimiter to split'
                        inputValue={firstInputValue}
                        setInputValue={setFirstInputValue}
                        setInputFocused={setFirstInputFocused}
                    />
                </div>
            </div>

            <div
                style={{ display: 'flex', flexDirection: 'column', marginTop: "10px" }}
                onMouseEnter={() => setSecondSourceCardHoverActive(true)}
                onMouseLeave={() => setSecondSourceCardHoverActive(false)}
            >
                <span style={{ fontWeight: 'bold', color: 'gray', textAlign: 'start', display: 'flex', gap: '10px', justifyContent: "space-between" }}>Index</span>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    margin: '0 4px',
                    padding: "0 4px",
                    position: 'relative',
                    paddingRight: '10px',
                    border: secondInputFocused ? '1px solid #2BB9BB' : '1px solid lightgray',
                    color: 'rgb(128, 128, 128)',
                    marginTop: "5px"                    
                }}>
                    
                    <NumberInput
                        onBlur={() => {
                            updateSourceData(propKey, 1, secondInputValue);
                        }}
                        autoFocus={false}
                        inputValue={secondInputValue}
                        setInputFocused={setSecondInputFocused}
                        setInputValue={setSecondInputValue}
                        onKeyDown={(e) => {
                            if (e.key === '.' || e.key === ',' || e.key === 'e' || e.key === 'E') {
                                e.preventDefault();
                            }
                        }}
                    />
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: "10px" }}>
                <span style={{ fontWeight: 'bold', color: 'gray', textAlign: 'start', display: 'flex', gap: '10px', justifyContent: "space-between", marginBottom: "5px" }}>Direction</span>
                <DirectionToggleButton onChange={(currentDirection) => {updateSourceData(propKey, 2, currentDirection)}} direction={directionInputValue} setDirection={setDirectionInputValue} />
            </div>
        </div>
    );
};

export const mapStateToProps = (state: any) => {
    return {
        tabTileProps: state.tabTileProps,
        calculations: state.calculations,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {
        addSourceInfoIntoCalculationFlow: (
            tableId: string,
            calculationFlow: { uid: string; flow: string },
            propKey: string,
            dataType: string,
            isAggregation: boolean,
            aggregation: string,
            conditionNumber: number
        ) =>
            dispatch(
                addSourceInfoInCalculationFlow(
                    tableId,
                    calculationFlow,
                    propKey,
                    dataType,
                    isAggregation,
                    aggregation,
                    conditionNumber
                )
            ),
        updateSourceData: (propKey: string, sourceIndex: number, newSourceValue: string) =>
            dispatch(updateSource(propKey, sourceIndex, newSourceValue))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SplitSettings);